import { apiService as api } from './apiService';

export interface SiteSettings {
    admin_whatsapp_phones: string[];
    gift_category_order: string[];
}

export const settingsApi = {
    async getSettings(): Promise<SiteSettings> {
        return api.request<SiteSettings>('/settings');
    },

    async updateSettings(settings: Partial<SiteSettings>): Promise<void> {
        await api.request<void>('/settings', {
            method: 'POST',
            body: JSON.stringify(settings)
        });
    }
};
